module.exports = __webpack_public_path__ + "img/11.3f3de30e.svg";